import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import { HomeService } from '../home-service/home.service';

interface IconeTarefa {
  nome: string;
  fontSet?: string;
}

@Component({
  selector: 'app-bloco-tarefas',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
  templateUrl: './bloco-tarefas.component.html',
  styleUrls: ['./bloco-tarefas.component.scss'],
})
export class BlocoTarefasComponent implements OnInit {
  loading    = true;
  paraHoje   = 0;
  atrasadas  = 0;
  pendentes  = 0;
  concluidas = 0;
  proximasTarefas: any[] = [];


  private readonly iconesPorAcao: Record<string, IconeTarefa> = {
    'Telefonar':            { nome: 'call' },
    'Visitar':               { nome: 'directions_car' },
    'Em especificação':      { nome: 'description' },
    'Em negociação':         { nome: 'handshake', fontSet: 'material-symbols-outlined' },
    'Em orçamento':          { nome: 'request_quote', fontSet: 'material-symbols-outlined' },
    'Enviar orçamento':      { nome: 'send' },
    'Futura prospecção':     { nome: 'explore' },
    'Previsão de cotação':   { nome: 'event' },
    'Mensagem WhatsApp':     { nome: 'chat' },
  };

  private readonly iconePadrao: IconeTarefa = { nome: 'task_alt' };

  constructor(
    private readonly homeService: HomeService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.homeService.getTaskSummary(30).subscribe({
      next: (res) => {
        const d          = res?.data;
        this.paraHoje        = d?.paraHoje   ?? 0;
        this.atrasadas       = d?.atrasadas  ?? 0;
        this.pendentes       = d?.pendentes  ?? 0;
        this.concluidas      = d?.concluidas ?? 0;
        this.proximasTarefas = d?.proximasTarefas ?? [];
        this.loading         = false;
      },
      error: () => { this.loading = false; },
    });
  }

  getIconeTarefa(actionDescription: string): IconeTarefa {
    return this.iconesPorAcao[actionDescription] ?? this.iconePadrao;
  }
}